import { render, staticRenderFns } from "./UserBind.vue?vue&type=template&id=3839b9f3&scoped=true&"
import script from "./UserBind.vue?vue&type=script&lang=js&"
export * from "./UserBind.vue?vue&type=script&lang=js&"
import style1 from "./UserBind.vue?vue&type=style&index=1&id=3839b9f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3839b9f3",
  null
  
)

export default component.exports